// ui/src/lib/config.js

/**
 * Shared configuration for the frontend application.
 * Safely bridges build-time globals injected by vite.config.js
 * alongside standard environment variable fallbacks.
 */

const RAW_PREFIX = typeof __API_BASE_PATH__ !== 'undefined'
    ? __API_BASE_PATH__
    : import.meta.env.VITE_API_BASE_PATH || import.meta.env.API_BASE_PATH || "/rapid-api";

// FORCE the leading slash so the browser never treats this as a relative path
const API_PREFIX = RAW_PREFIX.startsWith('/') ? RAW_PREFIX : `/${RAW_PREFIX}`;
const API_HOST = import.meta.env.VITE_API_HOST || "";

export const CONFIG = {
    API_BASE_URL: `${API_HOST}${API_PREFIX}`,
    TENANT_ID_HEADER: "X-Tenant-ID",
    POLL_INTERVAL: 5000,
};